import emailSuggestionComponentUrl from './emailSuggestionComponent.html';

class EmailSuggestionCtrl {
  constructor(sdk, SlingAnalytics) {
    'ngInject';

    Object.assign(this, { sdk, SlingAnalytics });
    this.getEmailSuggestion = sdk('utils').getEmailSuggestion;
  }

  setEmail(email) {
    this.emailModel = email;
    this.SlingAnalytics.track(this.SlingAnalytics.analyticsEvents.emailCorrected);
  }
}

export default {
  templateUrl: emailSuggestionComponentUrl,
  controller: EmailSuggestionCtrl,
  controllerAs: 'ctrl',
  bindings: {
    emailModel: '=',
    emailInputForm: '<',
  },
};
